<template>
  <div>
    <v-breadcrumbs :items="crumbs"></v-breadcrumbs>
    <base-loader :isLoading="isLoading"></base-loader>
    <v-row>
      <v-col md="6">
        <v-card>
          <v-card-text>
            <h4 class="text-md-h4 primary--text mb-5">
              {{ `${isEdit ? "Edit" : "New"} Industry` }}
            </h4>
            <v-form ref="industryForm" @submit.prevent="save()">
              <v-row>
                <v-col md="12">
                  <v-text-field
                    v-model="industryModel.name"
                    label="Industry Name"
                    required
                    outlined
                    :rules="[(v) => !!v || 'Industry Name is required']"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-btn type="submit" color="success">Save</v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { gql } from "apollo-boost";
import { Industry } from "@/models/Industry";
export default {
  data() {
    return {
      isEdit: false,
      isLoading: false,
      industryModel: new Industry(),
      me: "",
      search: null,
    };
  },
  created() {
    this.isEdit = this.$route.params.id != 0;
    this.isLoading = this.isEdit ? true : false;
  },
  computed: {
    crumbs() {
      return [
        {
          text: "Industries",
          disabled: false,
          href: "/admin/industries",
        },
        {
          text: "Industry Detail",
          disabled: false,
          href: `/admin/industries/${this.$route.params.id}`,
        },
        {
          text: `${this.isEdit ? "Edit" : "New"} Industry`,
          disabled: true,
        },
      ];
    },
  },
  watch: {},
  apollo: {
    me: gql`
      query {
        me {
          id
        }
      }
    `,
    industry: {
      query: gql`
        query Industry($id: ID!) {
          industry(id: $id) {
            id
            name
          }
        }
      `,
      fetchPolicy: "network-only",
      skip() {
        return !this.isEdit;
      },
      variables() {
        const self = this;
        return {
          id: self.$route.params.id,
        };
      },
      result(response, key) {
        this.isLoading = false;
        this.industryModel.id = this.industry.id;
        this.industryModel.name = this.industry.name;
      },
    },
  },
  methods: {
    async save() {
      this.isLoading = true;
      const self = this;
      if (!self.$refs.industryForm.validate()) {
        self.$swal("Error", "Validation failed", "error");
        self.isLoading = false;
        return;
      }
      if (self.isEdit) {
        // update
        await this.updateIndustry()
          .then(() => {
            this.$swal("Success!", "Industry was updated", "success");
          })
          .catch((e) => {
            this.$swal(
              "Error!",
              "something went wrong when trying to update the industry, check data and try again later!",
              "error"
            );
          });
      } else {
        // create
        await this.createIndustry()
          .then(() => {
            this.$swal("Success!", "Industry was created", "success");
            window.location.href = `/admin/industries/${self.industryModel.id}/edit`;
          })
          .catch((e) => {
            this.$swal(
              "Error!",
              `Something went wrong when creating the industry, check data and try again later!`,
              "error"
            );
          });
      }
      this.isLoading = false;
    },
    async updateIndustry() {
      const self = this;
      try {
        const response = await self.$apollo.mutate({
          mutation: gql`
            mutation update($industry: IndustryUpdateInput!) {
              updateIndustry(industry: $industry) {
                id
                updated
              }
            }
          `,
          variables: {
            industry: {
              id: self.industryModel.id,
              name: self.industryModel.name,
              createdBy: self.me.id,
            },
          },
        });
        if (!response) {
          throw "Something went wrong when creating the industry!";
        }
        if (response.errors && response.errors.length > 0) {
          throw response.errors[0];
        }
      } catch (e) {
        throw e.message;
      }
    },
    async createIndustry() {
      const self = this;
      try {
        const response = await self.$apollo.mutate({
          mutation: gql`
            mutation createIndustry($industry: IndustryCreateInput!) {
              createIndustry(industry: $industry) {
                id
              }
            }
          `,
          variables: {
            industry: {
              name: self.industryModel.name,
              createdBy: self.me.id,
            },
          },
        });

        if (!response) {
          throw "Something went wrong when creating the Industry Item!";
        }
        if (response.errors && response.errors.length > 0) {
          throw response.errors[0];
        }
        if (response && response.data.createIndustry) {
          self.industryModel.id = response?.data?.createIndustry?.id;
        }
      } catch (e) {
        throw e.message;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
